import { useContext } from "@nuxtjs/composition-api";

export function usePartnerActions () {
  const { $mutate, $query } = useContext();

  async function savePartner (submitData) {
    try {
      if (submitData.id !== null) {
        const UPDATE_PARTNER = await import("./updatePartner.graphql");
        return await $mutate(UPDATE_PARTNER, submitData);
      } else {
        const CREATE_PARTNER = await import("./createPartner.graphql");
        return await $mutate(CREATE_PARTNER, submitData);
      }
    } catch (e) {
      console.error(e);
      return Promise.reject(e);
    }
  }

  async function deletePartnerById (id) {
    try {
      const DELETE_PARTNER = await import("./deletePartnerById.graphql");
      await $mutate(DELETE_PARTNER, { id });
    } catch (e) {
      console.error(e);
      return Promise.reject(e);
    }
  }

  async function getPartnerById (id) {
    try {
      const GET_PARTNER = await import("./getPartnerById.graphql");
      const { partnerById } = await $query(GET_PARTNER, { id });
      return partnerById;
    } catch (e) {
      console.error(e);
      return Promise.reject(e);
    }
  }

  async function getPartners(params) {
    try {
      const GET_PARTNERS = await import("./partnersDataTable.graphql");
      const { partnersDataTable } = await $query(GET_PARTNERS, params);
      return partnersDataTable;
    } catch (e) {
      console.error(e);
      return Promise.reject(e);
    }
  }

  return {
    savePartner,
    deletePartnerById,
    getPartnerById,
    getPartners,
  };
}
